import React from "react";

import { API_ENDPOINT } from "../../../constants/appConstant";
import { useNetwork } from "../../../hooks/useNetwork";
import { ApopProps, CheckboxOptionType } from "../../../types";
import { Events } from "../common/json/clevertapEvents";
import { JobPreferencesApopUI } from "./JobPreferencesUI";

type UpdatedData = {
  [key: string]: any;
};

export const JobPreferencesApop = ({
  nextApopType,
  onCTA,
  toast,
  prefilledData,
  closeApop,
  handleEventTracking,
}: ApopProps) => {
  const { response: apiResponse, fetchData: submitFetchApi } = useNetwork();

  function removeKeys(
    originalArray: CheckboxOptionType[],
    keysToRemove: (keyof CheckboxOptionType)[],
  ): Omit<CheckboxOptionType, keyof typeof keysToRemove>[] {
    return originalArray.map((obj) => {
      const newObj = { ...obj };
      keysToRemove.forEach((key) => delete newObj[key]);
      return newObj;
    });
  }

  function skillsOutputHandler(
    originalArray: Omit<CheckboxOptionType, keyof CheckboxOptionType[]>[],
  ) {
    let newArr: any = [];
    originalArray.forEach((obj) => {
      newArr.push({ skill: obj });
    });
    return newArr;
  }

  const onSubmit = async (data: any) => {
    const skillArray = removeKeys(data.keySkills, ["value", "id", "selected"]);
    const updatedData: UpdatedData = {
      jobPreference: {
        skills: skillsOutputHandler(skillArray),
        // ...(!isExperienced && {
        roles: removeKeys(data.jobTitle, ["value", "text", "selected"]),
        // }),
      },
    };

    if (data.linkedin) {
      updatedData["socialPresence"] = {
        url: data.linkedin,
        name: "LinkedIn",
      };
      handleEventTracking({
        eventType: "eventPush",
        eventName: Events["LINKED_IN"].linkedInClick["EVENTNAME"],
        eventProps: Events["LINKED_IN"].linkedInClick["EVENTOBJ"],
      });
    }

    if (data.isToggled) {
      updatedData["profileAutoUpdate"] = {
        linkedInConsent: true,
      };
    } else {
      updatedData["profileAutoUpdate"] = {
        linkedInConsent: false,
        reason: "OTHER_REASONS",
      };
    }

    handleEventTracking({
      eventType: "eventPush",
      eventName: Events["JOB_PREFERENCES"].submitEvent["EVENTNAME"],
      eventProps: Events["JOB_PREFERENCES"].submitEvent["EVENTOBJ"],
    });

    const res = await submitFetchApi(
      API_ENDPOINT().seekerProfile.jobPreferencesMiddleware,
      "PUT",
      {},
      updatedData,
    );

    onCTA && onCTA("JOB_PREFERENCES");

    if (res.data) {
      const nextAction = (res.data as any)?.nextActionRequired?.actionType;
      nextApopType(
        nextAction ?? "",
        (res.data as any)?.nextActionRequired ?? null,
      );
      toast &&
        toast({
          showToast: true,
          text:
            (res.data as any)?.successMessage ?? "Section updated successfully",
          type: "success",
        });

      if (data.linkedin) {
        handleEventTracking({
          eventType: "eventPush",
          eventName: Events["LINKED_IN"].linkedInAdded["EVENTNAME"],
          eventProps: Events["LINKED_IN"].linkedInAdded["EVENTOBJ"],
        });
      }
    } else {
      toast &&
        toast({
          showToast: true,
          text:
            (res.error as any)?.error?.message?.errorMessage ??
            "Something went wrong",
          type: "error",
        });
    }
  };

  return (
    <JobPreferencesApopUI
      prefilledData={prefilledData}
      closeApop={closeApop}
      onSubmit={onSubmit}
      isSubmitAPILoading={apiResponse.isLoading}
    />
  );
};
